import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ServiceCardProps {
  label: string;
  title: string;
  tagline: string;
  description: string;
  items: string[];
  linkText: string;
  linkTo?: string;
  accentColor: 'primary' | 'secondary';
}
export function ServiceCard({
  label,
  title,
  tagline,
  description,
  items,
  linkText,
  linkTo = '#',
  accentColor
}: ServiceCardProps) {
  const accentClass = accentColor === 'primary' ? 'text-primary' : 'text-secondary';
  const bgBadgeClass = accentColor === 'primary' ? 'bg-primary/10 text-primary' : 'bg-secondary/10 text-secondary';
  return <div className="bg-white rounded p-8 shadow-warm border border-border flex flex-col h-full hover:shadow-lg transition-shadow duration-300" data-id="element-68">
      <div className="mb-6" data-id="element-69">
        <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider ${bgBadgeClass}`} data-id="element-70">
          {label}
        </span>
      </div>

      <h3 className="text-3xl font-serif font-semibold text-text mb-2" data-id="element-71">
        {title}
      </h3>
      <p className={`text-lg font-medium mb-4 ${accentClass}`} data-id="element-72">{tagline}</p>

      <p className="text-muted mb-8 leading-relaxed" data-id="element-73">{description}</p>

      <div className="flex-grow" data-id="element-74">
        <ul className="space-y-3 mb-8" data-id="element-75">
          {items.map((item, index) => <li key={index} className="flex items-center text-text" data-id="element-76">
              <span className="w-1.5 h-1.5 rounded-full mr-3 bg-primary" data-id="element-77" />
              {item}
            </li>)}
        </ul>
      </div>

      <Link to={linkTo} className="inline-flex items-center font-semibold transition-colors text-primary hover:opacity-80" data-id="element-78">
        {linkText}
        <ArrowRight className="ml-2 w-4 h-4" data-id="element-79" />
      </Link>
    </div>;
}